import { Languages } from "@/hooks/useTranslation/useTranslation"
import type { SignUpInput } from "aws-amplify/auth"

// The signup-welcome mail localizes on this attribute; setting it in the
// signUp call itself means the CustomMessage trigger already sees it.
export const withSignUpLanguage = (
  input: SignUpInput,
  language: string,
): SignUpInput => ({
  ...input,
  options: {
    ...input.options,
    userAttributes: {
      ...input.options?.userAttributes,
      "custom:language": Object.keys(Languages).includes(language)
        ? language
        : "DE",
    },
  },
})
